import axios from "axios";
import { toast } from "react-toastify";
import AccountHeader from "../../components/layout/accounts-header/account-header";
import { getAccountsUrl } from "../../utils/accountsUrl";
import { globalGetApiUrl } from "../../utils/globalBaseUrl";
import LocalStorageService from "./../../core/services/local-storage.service";
import { ERROR_MESSAGE } from "../../utils/const";

const intelHeader = {
  logoutUser: globalGetApiUrl("auth/logout"),
};
const localStorageService = LocalStorageService.getService();

const NoProductAssignedPage = () => {
  const logoutButtonFunction = async () => {
    try {
      const res = await axios.get(intelHeader.logoutUser);
      if (res.data.status.toLocaleUpperCase() === "success".toLocaleUpperCase()) {
        localStorageService.clearCompleteStorage();
        window.location.href = getAccountsUrl() + "signout";
      } else {
        toast.error(res.data.message);
      }
    } catch {
      toast.error(ERROR_MESSAGE);
    }
  };

  return (
    <>
      <AccountHeader type="no-product-assigned" />
      <div className="no-product-background d-flex justify-content-center align-items-center">
        <div className="white-box flex-column d-flex justify-content-center align-items-center p-5">
          <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1693208098/intel/icons/error_szfugc.svg" alt="icon" />
          <p className="m-0 text-center">No Product has been assigned to your email address. Please contact your admin for assigning product</p>
          <button className="fw-bold" onClick={() => logoutButtonFunction()}>
            Logout
          </button>
        </div>
      </div>
    </>
  );
};

export default NoProductAssignedPage;
